








import { Component, Vue } from 'vue-property-decorator'

import firebase from 'firebase/app'
import 'firebase/firestore'

import { db } from '@/database'

// Types
import { Match } from '@/types/match'

// Views / components
import MainLayout from '@/views/layout/Main.vue'
import MatchList from '@/components/MatchList.vue'

@Component({
  components: {
    MainLayout,
    MatchList,
  },

  firestore() {
    const timeDelta = 60 * 60 * 3 * 1000 // Matches kicking off up to three hours ago
    const timestampArchiveScope = firebase.firestore.Timestamp.fromMillis(
      firebase.firestore.Timestamp.now().toMillis() - timeDelta
    )
    return {
      matches: db
        .collection('matches')
        // Firestore - where query on collection
        .where('kickoff', '<', timestampArchiveScope)
        // Firestore - Order a collection
        // https://firebase.google.com/docs/firestore/query-data/order-limit-data
        // Order by kickoff time (as close to now - in past)
        .orderBy('kickoff', 'desc'),
    }
  },
})
export default class MatchArchive extends Vue {
  matches: Match[] = []

  drawer = { state: null }
}
